import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

const Ribbon = ({ text = "", backgroundColor = "#910A2D", color = "#fff" }) => (
  <div
    data-test={"ribbon"}
    style={{
      position: "absolute",
      overflow: "hidden",
      fontSize: "70%",
      paddingTop: "2.3em",
      paddingLeft: "2.3em",
      height: "6em",
      width: "6em"
    }}>
    <div
      style={{
        backgroundColor,
        color,
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: "0.15em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transformOrigin: "top left",
        width: "12em",
        height: "2.2em",
        transform: "rotate(-45deg) translateX(-50%)"
      }}>
      <p style={{ margin: "0 0 -0.18em 0" }}>{text}</p>
    </div>
  </div>
)

Ribbon.propTypes = {
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  color: PropTypes.string
}

export default Radium(Ribbon)



// WEBPACK FOOTER //
// ./src/containers/ribbon/index.jsx